export const TEACHER_SIGNUP = "TEACHER_SIGNUP";
export const LOGOUT_USER = "LOGOUT_USER";
export const TEACHER_COMMON_API = "TEACHER_COMMON_API";
export const GET_ACTIVITY = "GET_ACTIVITY";
export const GET_HOMEWORK = "GET_HOMEWORK";
export const GET_TEACHER_FEEDBACK = "GET_TEACHER_FEEDBACK";


